import { render, staticRenderFns } from "./ConfirmationPopup.vue?vue&type=template&id=52ff5667&scoped=true&"
import script from "./ConfirmationPopup.vue?vue&type=script&lang=js&"
export * from "./ConfirmationPopup.vue?vue&type=script&lang=js&"
import style0 from "../Style/confirmation-popup.scss?vue&type=style&index=0&id=52ff5667&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ff5667",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Data\\TeamCity\\buildAgent\\work\\6dffdb6616650f37\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52ff5667')) {
      api.createRecord('52ff5667', component.options)
    } else {
      api.reload('52ff5667', component.options)
    }
    module.hot.accept("./ConfirmationPopup.vue?vue&type=template&id=52ff5667&scoped=true&", function () {
      api.rerender('52ff5667', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/ConfirmationPopup.vue"
export default component.exports